module.exports = __webpack_public_path__ + "img/news_hacking.e856ab33.jpg";